export default "__VITE_ASSET__5fa19315__"